// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  orgId: __t.string().primaryKey().name("org_id"),
  repoOwner: __t.string().name("repo_owner"),
  repoName: __t.string().name("repo_name"),
  defaultLabels: __t.string().name("default_labels"),
  updatedAt: __t.timestamp().name("updated_at"),
  updatedByIdentity: __t.identity().name("updated_by_identity"),
  installationId: __t.u64().name("installation_id"),
  stamp: __t.option(__t.string()),
});
